import React, { useState, useEffect } from 'react';
import { FaUser, FaCalendar, FaArrowRight } from 'react-icons/fa';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const Blog = () => {
  const blogData = [
    {
      id: 1,
      title: "Full Body Home Workout",
      author: "Martin.C",
      date: "30 Dec 2025",
      description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Eius libero soluta impedit eligendi? Quibusdam, laudantium.",
      image: "img/feature-4.jpg",
    },
    {
      id: 2,
      title: "31-Day Fitness Calendar",
      author: "Martin.C",
      date: "30 Dec 2025",
      description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Eius libero soluta impedit eligendi? Quibusdam, laudantium.",
      image: "img/feature-3.jpg",
    },
    {
      id: 3,
      title: "At Home Ab Workout",
      author: "Martin.C",
      date: "30 Dec 2025",
      description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Eius libero soluta impedit eligendi? Quibusdam, laudantium.",
      image: "img/feature-2.jpg",
    },
    {
      id: 4,
      title: "Full Body Home Workout",
      author: "Martin.C",
      date: "30 Dec 2025",
      description: "Lorem, ipsum dolor sit amet consectetur adipisicing elit. Eius libero soluta impedit eligendi? Quibusdam, laudantium.",
      image: "img/feature-1.jpg",
    }
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  };

  return (
    <div className="container-fluid blog py-5">
      <div className="container py-5">
        <div className="text-center mx-auto pb-5" style={{ maxWidth: '800px' }}>
          <h4 className="text-primary">Our Blogs</h4>
          <h1 className="display-4 mb-4">Check out our latest stories</h1>
          <p className="mb-0">
            Lorem ipsum dolor, sit amet consectetur adipisicing elit. Tenetur adipisci facilis cupiditate recusandae aperiam temporibus corporis itaque quis facere, numquam, ad culpa deserunt sint dolorem autem obcaecati, ipsam mollitia hic.
          </p>
        </div>

        <div className="blog-carousel">
          <Slider {...settings}>
            {blogData.map((blog) => (
              <div key={blog.id} className="blog-item px-2">
                <div className="blog-img p-4 pb-0">
                  <a href="#">
                    <img src={blog.image} className="img-fluid w-100" alt={blog.title} />
                  </a>
                </div>
                <div className="blog-content p-4">
                  <div className="blog-comment d-flex justify-content-between py-2 px-3 mb-4">
                    <div className="small">
                      <FaUser className="text-primary me-2" />
                      {blog.author}
                    </div>
                    <div className="small">
                      <FaCalendar className="text-primary me-2" />
                      {blog.date}
                    </div>
                  </div>
                  <a href="#" className="h4 d-inline-block mb-3">{blog.title}</a>
                  <p className="mb-3">{blog.description}</p>
                  <a href="#" className="btn btn-dark py-2 px-4 ms-2">
                    <span className="me-2">Read More</span>
                    <FaArrowRight />
                  </a>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </div>
    </div>
  );
};

export default Blog;